import { useState, useRef } from "react";
import { api, fileUrl, apiError } from "../lib/api";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

export const ImageUpload = ({ value, onChange, label = "Slika", shape = "square", testId }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const res = await api.post("/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(res.data.path);
      toast.success("Slika učitana");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  const rounded = shape === "circle" ? "rounded-full" : "rounded-none";

  return (
    <div className="flex items-center gap-4">
      <div
        className={`w-20 h-20 border-2 border-dashed border-border flex items-center justify-center overflow-hidden bg-muted ${rounded}`}
      >
        {value ? (
          <img src={fileUrl(value)} alt={label} className="w-full h-full object-cover" />
        ) : (
          <Upload className="w-6 h-6 text-muted-foreground" />
        )}
      </div>
      <div>
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="text-sm font-semibold px-4 py-2 border-2 border-foreground hover:bg-foreground hover:text-background transition-colors flex items-center gap-2"
          data-testid={testId}
        >
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {value ? "Promijeni" : `Učitaj ${label.toLowerCase()}`}
        </button>
        <p className="text-xs text-muted-foreground mt-1">JPG, PNG, WEBP</p>
      </div>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
    </div>
  );
};
